import{e as n,m as t}from"./chunk-HBP5N4FR.js";var i,d,f,r=n(()=>{t();i=!1,d=(e=!0)=>{i=e},f=(e,o=0)=>{i||setTimeout(()=>{window.location.href=e,window.location.assign(e)},o)}});export{d as a,f as b,r as c};
//# sourceMappingURL=chunk-DZ5IJ4N3.js.map
